import { Validators } from '@angular/forms';

export const SlideItemSchema = {
    'fields': [{
        'field': 'id',
        'value': null,
        'validators': [],
    }, {
        'field': 'imageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'imageDataUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.imageUrl === '' ? '/images/blank_2x1.png': data.imageUrl
            }
        }
    }, {
        'field': 'imageUrl',
        'type': 'string',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value;
            }
        }
    }, {
        'field': 'vImageUrl',
        'type': 'string',
        'value': '/images/blank_2x1.png',
        'column': 1,
        'validators': [],
        'options': {
            'virtual': false,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value
            }
        }
    }, {
        'field': 'name',
        'type': 'string',
        'value': '',
        'column': 0,
        'validators': [Validators.required, Validators.maxLength(128)]
    }]
};